import { Button, CardContent } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";
import palette from "src/theme/palette";

import Context from "./context";

// ----------------------------------------------------------------------

export const CustomContent = () => {
	const { actions } = useContext(Context);
	const { translate } = useLocales();
	return (
		<CardContent sx={{ pt: 1 }}>
			<Button
				variant='contained'
				onClick={() => actions.showCustomDialog("LIGHT")}
				style={{ backgroundColor: palette.light.primary.light }}
				startIcon={<Iconify icon={"material-symbols:light-mode"} />}
			>
				{translate("customization.light")}
			</Button>
			<Button
				variant='contained'
				sx={{ ml: 2 }}
				onClick={() => actions.showCustomDialog("DARK")}
				style={{ backgroundColor: palette.light.text.primary }}
				startIcon={<Iconify icon={"material-symbols:dark-mode-outline"} />}
			>
				{translate("customization.dark")}
			</Button>
		</CardContent>
	);
};

export default CustomContent;
